import { cache } from "lib/apolloClient";
import {
  courseBookmarkStatusFragment,
  classBookmarkStatusFragment,
} from "./LearningCoursesListFragments";

export const writeCourseBookmarkStatusInCache = ({ id, isBookmarked }) => {
  cache.writeFragment({
    id: `LearningCourse:${id}`,
    fragment: courseBookmarkStatusFragment,
    fragmentName: "courseBookmarkStatus",
    data: {
      id,
      isBookmarked,
    },
  });
};

export const writeClassBookmarkStatusInCache = ({ id, isBookmark }) => {
  cache.writeFragment({
    id: `Course:${id}`,
    fragment: classBookmarkStatusFragment,
    fragmentName: "classBookmarkStatus",
    data: {
      id,
      isBookmark,
    },
  });
};
